import React from 'react'
import ContentSection from '../../../components/ContentSection'
import ContentSectionHeader from '../../../components/ContentSectionHeader'
import ContentMultiCardSignpost from '../../../components/ContentMultiCardSignpost'
import styled from 'styled-components'
import { Box, Flex } from 'rebass'
import typography from '../../../utils/typography'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
`

const FlexWrapperInner = styled(Box)`
  width: 100%;
  max-width: ${(props) => props.theme.content.max.width};
  margin-left: auto;
  margin-right: auto;
`

const normaliseImages = (item) => {
  return {
    ...item,
    image:
      item.images &&
      item.images.widgets &&
      item.images.widgets[0] &&
      item.images.widgets[0].crops &&
      item.images.widgets[0].crops[0] &&
      item.images.widgets[0].crops[0].src
  }
}

const SignpostWidget = ({
  title,
  heading,
  decorativeText,
  items,
  backgroundColor
}) => (
  <ContentSection
    title={decorativeText}
    fg="#FFFFFF"
    bg={backgroundColor || '#EEF4F9'}
    opacity={0.65}
    mt={0}
  >
    <ContentSectionHeader heading={heading} title={title} fg="#1E4F67" />
    <FlexWrapper
      mt={[null, null, typography.rhythm(1)]}
      mb={[typography.rhythm(1), typography.rhythm(2), typography.rhythm(3)]}
      flexWrap="wrap"
    >
      <FlexWrapperInner>
        <ContentMultiCardSignpost articles={items.map(normaliseImages)} />
      </FlexWrapperInner>
    </FlexWrapper>
  </ContentSection>
)

export default SignpostWidget
